import { useContext, useEffect, useState } from "react";
import { Answer } from "./Answer";
import { AppContext } from "../context/AppContext";
import "../style/quiz.css"
import { decode } from 'html-entities';

export function Question(props) {
    const appContext = useContext(AppContext);
    const categoryImage = props.category;
    const [shuffledAnswers, setShuffledAnswers] = useState([]);
    const [canAnswer, setCanAnswer] = useState(true);
    const [time, setTime] = useState(0);
    let qTime = null;

    useEffect(()=>{
        setShuffledAnswers(shuffleAnswers([props.correctAnswer, props.incorrectAnswer1, props.incorrectAnswer2, props.incorrectAnswer3]));
        //console.log(props.correctAnswer);
    },[]);


    useEffect(()=>{
        setTime(0);
        qTime = setInterval(() => {
            setTime(time => time + 0.01);
          }, 10);
        return () => clearInterval(qTime);
    },[props.visible]);


    const shuffleAnswers = (answers) => {
        for (var i = answers.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            var temp = answers[i];
            answers[i] = answers[j];
            answers[j] = temp;
        }

        return answers;
    };

    const reportQuestion = (result) => {
        let quizStats = appContext.quizStats;
            quizStats.push({
            "correct": result,
            "category": props.category,
            "time": time
        });
        appContext.updateQuizStats(quizStats);
    };

    const checkAnswer = (text, prefix) => {
        if (canAnswer) {
            if (text === decode(props.correctAnswer)) {
                reportQuestion(true);
                document.getElementById(prefix).classList.add("correct");
            } else {
                reportQuestion(false);
                document.getElementById(prefix).classList.add("incorrect");
                const prefixes = ["A", "B", "C", "D"]
                for (var i = 0; i < prefixes.length; i++) {
                    if (document.getElementById(prefixes[i]).textContent.substring(1) === decode(props.correctAnswer)) {
                        document.getElementById(prefixes[i]).classList.add("correct");
                    }
                }
            }
            setCanAnswer(false);

            const interval = setInterval(() => {
                props.next();
                clearInterval(interval);
              }, 1000);
        }
    };
    
    return (
        props.visible ? 
            <div className="question-frame">
                <div className="question-area">
                    <div className="question">
                        <div className="category-container">
                            <img 
                                src={require("../media/" + categoryImage + ".png")} 
                                alt="question category"
                                className="category"/>
                        </div>
                        <div className="difficulty">
                            <img 
                                src={require("../media/star.png")} 
                                alt="star"
                                className="difficulty-star"/>
                            {props.difficulty !== "easy" ? 
                                <img 
                                    src={require("../media/star.png")} 
                                    alt="star"
                                    className="difficulty-star"/> :
                                <img 
                                    src={require("../media/star-empty.png")} 
                                    alt="star"
                                    className="difficulty-star"/>
                            }
                            {props.difficulty === "hard" ? 
                                <img 
                                    src={require("../media/star.png")} 
                                    alt="star"
                                    className="difficulty-star"/> :
                                <img 
                                    src={require("../media/star-empty.png")} 
                                    alt="star"
                                    className="difficulty-star"/>
                            }
                        </div>
                        <p className="question-text">
                            {decode(props.questiontext)}
                        </p>
                    </div>
                </div>
                <div className="answers">
                    <Answer prefix="A" text={decode(shuffledAnswers[0])} next={()=>{checkAnswer(decode(shuffledAnswers[0]), "A")}}/>
                    <Answer prefix="B" text={decode(shuffledAnswers[1])} next={()=>{checkAnswer(decode(shuffledAnswers[1]), "B")}}/>
                    <Answer prefix="C" text={decode(shuffledAnswers[2])} next={()=>{checkAnswer(decode(shuffledAnswers[2]), "C")}}/>
                    <Answer prefix="D" text={decode(shuffledAnswers[3])} next={()=>{checkAnswer(decode(shuffledAnswers[3]), "D")}}/>
                </div>
            </div>
        : <div></div>
    );
}